import React from 'react';
import { EditButton, useRefresh } from 'react-admin';
import { default as DeleteButton } from "./DeleteButton";

const ItemActions = ({ basePath, record, solutionID }) => {
  const refresh = useRefresh();

  const handleDomainDelete = () => {
    refresh();
  }

  let deleteButton = '';

  if (record.isRemovable === true) {
    deleteButton = 
      <DeleteButton record={record} onSuccess={handleDomainDelete} />;
  }
  return (
    <>
      <EditButton
        basePath={basePath}
        record={record}>
      </EditButton>
      {deleteButton}
    </>
  );

}

export default ItemActions;
